import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {ApplicationMessageResource, ApplicationsService} from "../../core/modules/openapi";
import {MAT_DIALOG_DATA, MatDialogClose} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-application-messages',
  imports: [
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatTableModule,
    MatDialogClose,
    DatePipe
  ],
  templateUrl: './application-messages.component.html',
  styleUrl: './application-messages.component.sass',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationMessagesComponent {
  displayedColumns: string[] = ['creationDateTime', 'detail'];
  dataSource: MatTableDataSource<ApplicationMessageResource> = new MatTableDataSource<ApplicationMessageResource>(undefined);

  constructor(protected readonly router: Router, private readonly applicationsService: ApplicationsService, private readonly route: ActivatedRoute, @Inject(MAT_DIALOG_DATA) public data: {
    applicationId: string
  }) {
    let appId = this.route.snapshot.paramMap.get('id')!;
    if (!appId) {
      appId = this.data.applicationId;
    }
    this.applicationsService.getApplicationMessages(appId).subscribe(response => {
      this.dataSource.data = response;
      return response;
    });
  }

  closeWindow() {
    this.router.navigate(['home']);
  }
}
